export default "__VITE_ASSET__fCXmzUtU__"